
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".7","d":"M44.6 45.7c-4.9 2.1-26.2 11.6-34.2 16.2C6.9 60.5 4 59.5 0 58c16.6-9.5 34.6-15 34.9-15.5 3.4 1 6.2 2.4 9.7 3.2zM60.6 52.4c-4.9 2.1-26.4 12.4-34.3 17.1-3.7-1.9-7.3-3.7-11.1-5.2C31.8 54.6 49 48.2 49.3 47.8c3.1 1.2 7.9 3.2 11.3 4.6z"}}),_c('path',{attrs:{"d":"M112.2 48.7c-4.9 2.1-38.6 13-70.5 34.2-4-2.5-10.6-6.2-14.5-7.5 16.6-9.7 38.5-24.2 72-32.8 5.1 2.2 8.5 4.1 13 6.1zM128 57.5c-4.9 2.1-45.8 21.6-65.6 38.9-3.6-2.1-11.5-8.1-15.2-10 15.9-10.3 36.1-25.1 69.2-35.1 5.1 2.2 7.5 3.9 11.6 6.2zM44.8 35.4c8.7 2.8 21.5 7.3 29.8 11.5-2.6 1.4-6.2 2.4-9.4 3.7C44 41.7 35.4 39.1 35 38.8c2-.8 8.2-2.8 9.8-3.4zM60.3 31.5c8.7 2.8 22 6.6 30.4 10.9-2.8.7-6.9 1.5-10.2 2.9-21.2-8.9-29-11.2-29.4-11.5 1.9-.8 7.6-1.8 9.2-2.3z"}})])
          )
        }
      }
    